import React from "react";
import {
  UtensilsCrossed,
  Coffee,
  Car,
  Zap,
  Droplets,
  GlassWater,
  Video,
  Users,
  MapPin,
  Leaf,
} from "lucide-react";

const ITEMS = [
  {
    icon: UtensilsCrossed,
    title: "Homemade Food",
    desc: "Authentic Kerala home cooking for breakfast, lunch and dinner — prepared fresh by our family kitchen.",
  },
  {
    icon: Coffee,
    title: "Free 24-Hr Tea & Coffee Lounge",
    desc: "Self-service and prepared tea and coffee available around the clock — help yourself any time of day or night.",
  },
  {
    icon: Car,
    title: "Free Spacious Concrete Parking",
    desc: "Ample secure parking for cars, bikes and tourist vehicles — free of charge for all guests.",
  },
  {
    icon: Zap,
    title: "24-Hour Power Supply",
    desc: "Uninterrupted electricity throughout your stay — no load-shedding surprises.",
  },
  {
    icon: Droplets,
    title: "24-Hour Hot Water",
    desc: "Reliable hot water in every bathroom, available at any hour.",
  },
  {
    icon: GlassWater,
    title: "24-Hour Filter Water",
    desc: "Clean, purified drinking water available at all times — no need to buy bottled water.",
  },
  {
    icon: Video,
    title: "CCTV Security",
    desc: "Full CCTV coverage across the property for your peace of mind throughout your stay.",
  },
  {
    icon: Users,
    title: "Owner Family On-Site",
    desc: "Our family lives on the property — always available 24 hours to assist with anything you need.",
  },
  {
    icon: MapPin,
    title: "Easy Access to All Attractions",
    desc: "Centrally located near Sengulam Dam — all major Munnar tourist spots are within easy reach.",
  },
  {
    icon: Leaf,
    title: "Peaceful & Calm Setting",
    desc: "Away from the noise of the town, surrounded by nature — the perfect environment to truly unwind.",
  },
];

const WhatsIncluded = () => (
  <section id="included" className="py-20 md:py-28 bg-neutral-50">
    <div className="max-w-7xl mx-auto px-5 md:px-8">
      <div className="text-center mb-14">
        <p className="text-xs font-semibold tracking-[0.25em] uppercase text-[#17a89b] mb-4">
          What's Included
        </p>
        <h2 className="text-3xl md:text-5xl font-extrabold text-neutral-900 mb-4">
          Everything You Need, Nothing You Don't
        </h2>
        <p className="text-neutral-600 max-w-3xl mx-auto leading-8">
          Every stay at Auracrest Haven comes with a set of complimentary amenities that most
          resorts charge extra for — because we believe genuine hospitality means taking care of you
          completely.
        </p>
      </div>

      <div className="grid sm:grid-cols-2 lg:grid-cols-3 xl:grid-cols-5 gap-6">
        {ITEMS.map((item) => (
          <div
            key={item.title}
            className="bg-white rounded-2xl p-6 shadow-sm hover:shadow-md hover:-translate-y-1 transition-all duration-300"
          >
            <div className="w-12 h-12 rounded-xl bg-[#e3faf7] flex items-center justify-center mb-4">
              <item.icon className="w-6 h-6 text-[#17a89b]" />
            </div>
            <h3 className="text-base font-bold text-neutral-900 mb-2 leading-snug">
              {item.title}
            </h3>
            <p className="text-neutral-600 leading-7 text-sm">{item.desc}</p>
          </div>
        ))}
      </div>
    </div>
  </section>
);

export default WhatsIncluded;
